import {WixRicosViewer} from '@wix/ricos-viewer'
import {EVENTS_APP_ID} from '@wix/wix-events-commons-statics'
import {useEnvironment} from '@wix/yoshi-flow-editor'
import React, {ComponentProps} from 'react'
import {pluginAudio} from 'wix-rich-content-plugin-audio/loadable/viewer'
import {pluginCodeBlock} from 'wix-rich-content-plugin-code-block/viewer'
import {pluginCollapsibleList} from 'wix-rich-content-plugin-collapsible-list/loadable/viewer'
import {pluginDivider} from 'wix-rich-content-plugin-divider/loadable/viewer'
import {pluginEmoji} from 'wix-rich-content-plugin-emoji/viewer'
import {pluginFileUpload} from 'wix-rich-content-plugin-file-upload/loadable/viewer'
import {pluginGallery} from 'wix-rich-content-plugin-gallery/loadable/viewer'
import {pluginGiphy} from 'wix-rich-content-plugin-giphy/loadable/viewer'
import {pluginHashtag} from 'wix-rich-content-plugin-hashtag/viewer'
import {pluginHtml} from 'wix-rich-content-plugin-html/loadable/viewer'
import {pluginImage} from 'wix-rich-content-plugin-image/loadable/viewer'
import {pluginIndent} from 'wix-rich-content-plugin-indent/viewer'
import {pluginLineSpacing} from 'wix-rich-content-plugin-line-spacing/viewer'
import {pluginLink} from 'wix-rich-content-plugin-link/loadable/viewer'
import {LinkPreviewProviders} from 'wix-rich-content-plugin-link-preview'
import {pluginLinkPreview} from 'wix-rich-content-plugin-link-preview/loadable/viewer'
import {pluginSpoiler} from 'wix-rich-content-plugin-spoiler/viewer'
import {pluginVideo} from 'wix-rich-content-plugin-video/loadable/viewer'
import {usePageStateSelector} from '../../../hooks/state'
import {getEvent} from '../../../selectors/event'
import {RicosViewerProps} from './interfaces'

export const RicosViewer = ({content}: RicosViewerProps) => {
  const {isMobile} = useEnvironment()
  const eventId = usePageStateSelector(state => getEvent(state).id)
  const instance = usePageStateSelector(state => state.instance.instance)
  const msid = usePageStateSelector(state => state.instance.msid)

  return (
    <WixRicosViewer
      // @ts-expect-error
      content={content}
      instance={instance}
      msid={msid}
      plugins={plugins}
      theme={theme}
      isMobile={isMobile}
      biSettings={{consumer: 'Events', postId: eventId, containerId: EVENTS_APP_ID, platform: 'Livesite'}}
    />
  )
}

const plugins = [
  pluginAudio(),
  pluginCodeBlock(),
  pluginCollapsibleList(),
  pluginDivider(),
  pluginEmoji(),
  pluginFileUpload(),
  pluginGallery(),
  pluginGiphy(),
  pluginHashtag(),
  pluginHtml(),
  pluginImage(),
  pluginIndent(),
  pluginLineSpacing(),
  pluginLink(),
  pluginLinkPreview({
    exposeEmbedButtons: [LinkPreviewProviders.Instagram, LinkPreviewProviders.Twitter, LinkPreviewProviders.TikTok],
  }),
  pluginSpoiler(),
  pluginVideo(),
]

const theme: ComponentProps<typeof WixRicosViewer>['theme'] = {
  useWixStyles: true,
  typography: {
    fontFamily: 'var(--textFont-family)',
  },
  palette: {
    type: 'rgb',
    actionColor: 'var(--linksColor)',
    textColor: 'var(--textColor)',
  },
}
